import React from "react";
import { Link } from "react-router-dom";
import SectionTitle from "../../../Shared/SectionTitle/SectionTitle";
import AccesoiresData from "../../../../api/AccessoiresData";

const TeamSection = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section className="wpo-team-section section-padding">
      <div className="container">
        <SectionTitle
          subTitle={"Nous offrons"}
          MainTitle={"Plusieurs Accessoires"}
        />
        <div className="wpo-team-wrap">
          <div
            className="row"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {AccesoiresData.map((accessoire) => (
              <div
                className="col-lg-3 col-md-4 col-sm-6 col-12"
                key={accessoire.id}
              >
                <div className="wpo-team-item">
                  <div className="wpo-team-img">
                    <img src={accessoire.image} alt="" />
                    <Link
                      onClick={ClickHandler}
                      to={`/accesoires/${accessoire.id}`}
                    >
                      <i className="ti-plus"></i>
                    </Link>
                  </div>
                  <div className="wpo-team-text">
                    <h3>
                      <Link
                        onClick={ClickHandler}
                        to={`/accesoires/${accessoire.id}`}
                      >
                        {accessoire.homeTitle}
                      </Link>
                    </h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
